import React, {useState, useEffect} from 'react'
import { TextInput, PasswordInput, Button, Stack, Select, Group, Text } from '@mantine/core';
import { useForm } from '@mantine/form';
import { RegistrationFormValidations } from './validations/FormValidations';
import { AppDataService } from '../../services/AppDataService';
import useInfoModal from '../../hooks/useInfoModal';
import SkeletonGroup from '../SkeletonGroup';
import { useDispatch, useSelector } from 'react-redux';
import { update } from '../../redux/slices/authSlice';
import { MODAL_TYPE_ENUM } from '../../enums/CommonEnums';

const EditUserForm = ({ user }) => {
  const form = useForm({
    initialValues: {
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      phoneNumber: user.phoneNumber,
      title: user.title,
      companyName: user.companyName,
      companyAddressLine1: user.companyAddressLine1,
      companyAddressLine2: user.companyAddressLine2,
      companyCity: user.companyCity,
      companyState: user.companyState,
      companyZipCode: user.companyZipCode,
      companyEin: user.companyEIN,
      companyRole: user.companyRole,
      isAdmin: user.isAdmin,
      isOBRCMember: user.isOBRCMember,
    },

    // functions will be used to validate values at corresponding key
    validate: {
      firstName: RegistrationFormValidations.contactFirstName,
      lastName: RegistrationFormValidations.contactLastName,
      email: RegistrationFormValidations.contactEmail,
      phoneNumber: RegistrationFormValidations.contactPhoneNumber,
      title: RegistrationFormValidations.contactTitle,
      companyName: RegistrationFormValidations.companyName,
      companyAddressLine1: RegistrationFormValidations.companyAddressLn1,
      companyAddressLine2: RegistrationFormValidations.companyAddressLn2,
      companyCity: RegistrationFormValidations.companyCity,
      companyState: RegistrationFormValidations.companyState,
      companyZipCode: RegistrationFormValidations.companyZip,
      companyEin: RegistrationFormValidations.ein,
      companyRole: RegistrationFormValidations.companyRole
    }
  });
  const openModal = useInfoModal();
  const [loadingState, setLoadingState] = useState(false);
  const dispatch = useDispatch();

  const handleEditUser = async () => {
    try {
      setLoadingState(true);
  
      const webResp = await AppDataService.UpdateUser({id: user.id, ...form.values});
      const responseData = webResp.getResponse();
  
      setLoadingState(false);
  
      if(webResp.hasError()) return openModal(MODAL_TYPE_ENUM.GENERAL_FAILURE, responseData.error.message);
      else {
        dispatch(update(responseData.data.data))
        openModal(MODAL_TYPE_ENUM.GENERAL_SUCCESS, 'Your profile has been updated.');
      } 
    }
    catch(err) {
      setLoadingState(false);
      openModal(MODAL_TYPE_ENUM.GENERAL_FAILURE, err.message);
    }
  }

  return (
    <form onSubmit={form.onSubmit(handleEditUser)}>
      <Stack>
        <TextInput label="First Name" placeholder="First Name" size="md" {...form.getInputProps('firstName')} fullWidth />
        <TextInput label="Last Name" placeholder="Last Name" size="md" {...form.getInputProps('lastName')} fullWidth />
        <TextInput label="Email Address" placeholder='Email Address' size='md' {...form.getInputProps('email')} />
        <TextInput label="Title" placeholder='Title' size='md' {...form.getInputProps('title')} />
        <TextInput label="Phone Number" placeholder='Phone Number' size='md' {...form.getInputProps('phoneNumber')} />
        <TextInput label="Company Name" placeholder='Company Name' size='md' {...form.getInputProps('companyName')} />
        <TextInput label="Company Address Line 1" placeholder='Company Address Line 1' size='md' {...form.getInputProps('companyAddressLine1')} />
        <TextInput label="Company Address Line 2" placeholder='Company Address Line 2' size='md' {...form.getInputProps('companyAddressLine2')} />
        <TextInput label="Company City" placeholder='Company City' size='md' {...form.getInputProps('companyCity')} />
        <TextInput label="Company State" placeholder='Company State' size='md' {...form.getInputProps('companyState')} />
        <TextInput label="Company ZipCode" placeholder='Company ZipCode' size='md' {...form.getInputProps('companyZipCode')} />
        <TextInput label="Company EIN" placeholder='Company EIN' size='md' {...form.getInputProps('companyEin')} />
        <Select
          size='md'
          withinPortal={true}
          label='What is your company role?'
          dropdownPosition='bottom'
          placeholder='Company Role'
          {...form.getInputProps('companyRole')}
          data={[
            {value: 'Beverage Distributor', label: 'Beverage Distributor' },
            {value: 'Beverage Importer', label: 'Beverage Importer' },
            {value: 'Beverage Manufacturer', label: 'Beverage Manufacturer' },
          ]}
        />
      
        <Button fullWidth mt="xl" size="md" type="submit" loading={loadingState}>Save</Button>
      </Stack>
    </form>
  )
}

export default EditUserForm;